module.exports = __webpack_public_path__ + "static/media/wizualizacja-73.ead3a2a2.png";